module.exports = __webpack_public_path__ + "img/huace.dbe5a459.jpg";